module.exports = "<!-- * META-TAGS * -->\n<!--{{ meta.headerArea }}-->\n\n"